import {Collection} from "./collection";
import {BBModel} from "../bb_model";

class BookingCollection extends Collection {

    constructor(resource, set, params) {
        super(resource, set);
        this.promise = new Promise((resolve, reject) => {
            resource.$get('bookings').then((bookings) => {
                this.url = resource.$link('self').href;
                this.items = (Array.from(bookings).map(booking => new BBModel.Admin.Booking(booking)));
                this.items.forEach(booking => set.updateItem(booking));
                this.total_entries = resource.total_entries;
                if (params.start_date) this.start_date = moment(params.start_date, 'YYYY-MM-DD');
                if (params.end_date) this.end_date = moment(params.end_date, 'YYYY-MM-DD');
                if (this.end_date) this.end_date.set({hour: 24, minute: 0});
                this.params = params;
                this.include_cancelled = false;
                this.listenForPush(set);
                resolve(this);
            }, reject);
        });
    }

    checkParams(newBooking) {
        if (this.start_date && this.end_date && this.start_date.isSame(this.end_date, 'day') && !newBooking.datetime.isSame(this.start_date, 'day'))
            return false;
        if (this.start_date && this.end_date && !newBooking.datetime.isBetween(this.start_date, this.end_date))
            return false;
        if (this.params.person_id && newBooking.person_id != this.params.person_id)
            return false;
        if (this.params.slot_id && newBooking.slot_id != this.params.slot_id)
            return false;
        return true;
    }

    canMatch() {
        return (this.start_date && this.end_date) || this.params.slot_id;
    }

    addBooking(newBooking) {
        if (this.start_date && this.end_date) {
            if (newBooking.datetime.isBetween(this.start_date, this.end_date)) {
                this.items.push(newBooking);
                this.callListeners(newBooking, 'create');
            }
        }
    }

    updateBooking(newBooking) {
        const index = this.findIndex(newBooking.id);
        if (this.checkParams(newBooking)) {
            if (index > -1) {
                this.items[index] = newBooking;
                this.callListeners(newBooking, 'update');
            } else {
                this.addBooking(newBooking);
            }
        } else if (index > -1) {
            this.items.splice(index, 1);
            this.callListeners(newBooking, 'destroy');
        }
    }

    handlePush(push) {
        if (push.action == 'destroy') {
            this.pushDelete(push);
        } else {
            const newBooking = push.object;
            if (newBooking && newBooking.is_cancelled && !this.include_cancelled) {
                const index = this.findIndex(newBooking.id);
                if (index > -1) {
                    this.items.splice(index, 1);
                    this.callListeners(newBooking, 'destroy');
                }
            } else {
                if (this.canMatch()) {
                    switch (push.action) {
                        case 'create':
                            this.updateBooking(newBooking);
                            break;
                        case 'update':
                            this.updateBooking(newBooking);
                            break;
                    }
                } else {
                    this.$refetch(push.set).then(() => {
                        this.callListeners();
                    });
                }
            }
        }
    }

    static $query(set, company, params) {
        params = params || {};
        if (params.slot) params.slot_id = params.slot.id;
        if (params.date) {
            params.start_date = params.date;
            params.end_date = params.date;
        }
        if (params.per_page == null) params.per_page = 1024;
        if (params.include_cancelled == null) params.include_cancelled = false;
        return super.$query(BookingCollection, set, company, params);
    }

}

BookingCollection.group = 'bookings';

export {
    BookingCollection
}
